import { render, staticRenderFns } from "./LegacyEntry.vue?vue&type=template&id=31dee3bd&"
import script from "./LegacyEntry.vue?vue&type=script&lang=js&"
export * from "./LegacyEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports